import { useContext, useMemo } from 'react';
import {
  GroupFeaturesContext,
  AppPlatformContext,
  IsDemoEnvContext,
} from './contexts';

/** The filter-relevant group feature flags, defaulting to off while the features are still loading. */
export const useResolvedFilterFeatures = () => {
  const features = useContext(GroupFeaturesContext);
  return useMemo(
    () => ({
      hcpProfiles: features?.hcpProfiles ?? false,
      workspaces: features?.workspaces ?? false,
      engagementFilter: features?.engagementFilter ?? false,
    }),
    [features?.hcpProfiles, features?.workspaces, features?.engagementFilter]
  );
};

export const useGroupFeatures = () => {
  const context = useContext(GroupFeaturesContext);
  if (context === undefined) {
    throw new Error('useGroupFeatures must be used within ChatCompatabilityProvider');
  }
  return context;
};

export const useAppPlatform = () => {
  const context = useContext(AppPlatformContext);
  if (context === undefined) {
    throw new Error('useAppPlatform must be used within ChatCompatabilityProvider');
  }
  return context;
};

export const useIsDemoEnv = () => {
  const context = useContext(IsDemoEnvContext);
  if (context === undefined) {
    throw new Error('useIsDemoEnv must be used within ChatCompatabilityProvider');
  }
  return context;
};